import { useQuery } from "@tanstack/react-query";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";
import api from "@/lib/apiClient";

export const useSiteContent = () =>
  useQuery({ queryKey: ["site-content"], queryFn: async () => (await api.get("/site-content")).data });

export const PublicLayout = () => {
  const { data: content = {} } = useSiteContent();
  return (
    <div className="App min-h-screen flex flex-col bg-brand-ivory">
      <Navbar />
      <main className="flex-1">
        <Outlet context={{ content }} />
      </main>
      <Footer content={content} />
      <FloatingActions content={content} />
    </div>
  );
};
